module.exports = __webpack_public_path__ + "static/media/maimai_lounge.44715acc.jpg";